import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { PriceRangeValue } from 'entities/kyrgyzstan/model'

import { CurrencySom } from 'shared/constants'
import { priceShow } from 'shared/lib/priceShow'
import { RangeInput } from 'shared/ui/range-input'

import s from './styles.module.scss'

interface PriceRangeProps {
  defaultValue: PriceRangeValue
  min: number
  max: number
  onChange: (value: PriceRangeValue) => void
}

export const PriceRange = ({
  defaultValue,
  min,
  max,
  onChange,
}: PriceRangeProps) => {
  const { t } = useTranslation()
  const [currentMin, currentMax] = defaultValue

  return (
    <div className={s.priceSection}>
      <div className={s.rangeLabels}>
        <span className={clsx('medium-14', s.rangeLabel)}>
          {t('kyrgyzstan_block.filters.price.from')}
        </span>
        <span className={clsx('medium-14', s.rangeLabel)}>
          <span>
            {priceShow(String(currentMin))} {CurrencySom}
          </span>
          {' — '}
          <span>
            {priceShow(String(currentMax))} {CurrencySom}
          </span>
        </span>
      </div>
      <RangeInput
        min={min}
        max={max}
        value={defaultValue}
        onChange={(value) => onChange(value as PriceRangeValue)}
      />
    </div>
  )
}
